/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { FacebookIcon, Instagram } from 'lucide-react';
import RegeneratePostForm from './RegeneratePostForm';
import SchedulePost from './SchedulePost';
import FeedbackPostForm from './FeedbackPostForm';
import PostPreview from './PostPreview';

const PostModalContent = ({
  post,
  onRegenerateSubmit,
  showProductImage,
  socialAccounts = [],
  onScheduleSubmit,
  onCancelPost,
  onEditSubmit,
  onFeedbackSubmit,
  onClose,
  businessName,
  logo,
}) => {
  const [previewPlatform, setPreviewPlatform] = useState('instagram');
  const [isEditImageModalOpen, setIsEditImageModalOpen] = useState(false);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  return (
    <div className='relative flex-1 grid grid-cols-12 h-full'>
      {/* Preview Section */}
      <div className='relative col-span-12 lg:col-span-7 flex flex-col lg:gap-0 card-gradient' style={{ backgroundColor: 'var(--bg-surface)' }}>
        <div className='flex-shrink-0 pt-2 lg:pt-3'>
          {/* Platform Selector */}
          <div className='flex justify-center gap-2 lg:gap-4'>
            <button
              onClick={() => setPreviewPlatform('instagram')}
              className={`p-1.5 lg:p-2 rounded-full text-sm font-medium transition-colors ${
                previewPlatform === 'instagram'
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white'
                  : 'border'
              }`}
              style={previewPlatform !== 'instagram' ? { backgroundColor: 'var(--bg-card)', color: 'var(--text-body)', borderColor: 'var(--border)' } : {}}
            >
              <Instagram className='w-4 h-4 lg:w-6 lg:h-6' />
            </button>
            <button
              onClick={() => setPreviewPlatform('facebook')}
              className={`p-1.5 lg:p-2 rounded-full text-sm font-medium transition-colors ${
                previewPlatform === 'facebook'
                  ? 'bg-blue-700 text-white'
                  : 'border'
              }`}
              style={previewPlatform !== 'facebook' ? { backgroundColor: 'var(--bg-card)', color: 'var(--text-body)', borderColor: 'var(--border)' } : {}}
            >
              <FacebookIcon className='w-4 h-4 lg:w-6 lg:h-6' />
            </button>
          </div>
        </div>

        {/* Preview Area */}
        <div
          className={
            'tour-post-modal-preview flex-1 flex  justify-center min-h-0 relative  px-2 lg:px-4 py-2 lg:py-4 '
          }
        >
          <div
            className={`flex flex-col items-center justify-center 
            
              `}
          >
            <div
              className={`max-w-[80%] md:max-w-[40%] ${post.aspectRatio === '1:1' ? 'lg:max-w-[70%]' : 'lg:max-w-[50%]'}`}
            >
              <PostPreview
                post={post}
                layout={post.aspectRatio === '1:1' ? 'feed' : 'story'}
                businessName={businessName}
                logo={logo}
                platform={previewPlatform}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='col-span-12 lg:col-span-5 p-2 md:p-6 lg:border-l z-auto shadow-left tour-post-modal-right-section' style={{ borderColor: 'var(--border)' }}>
        {isEditImageModalOpen && post?.status !== 'published' ? (
          <RegeneratePostForm
            post={post}
            onRegenerateSubmit={(userInput) => {
              onRegenerateSubmit(userInput);
            }}
            showProductImage={showProductImage}
            onCancel={() => setIsEditImageModalOpen(false)}
          />
        ) : isFeedbackModalOpen ? (
          <FeedbackPostForm
            post={post}
            onFeedbackSubmit={(userInput) => onFeedbackSubmit(userInput)}
            onCancel={() => setIsFeedbackModalOpen(false)}
          />
        ) : (
          <SchedulePost
            post={post}
            socialAccounts={socialAccounts}
            onScheduleSubmit={onScheduleSubmit}
            onCancelPost={onCancelPost}
            onEditSubmit={onEditSubmit}
            onEditImageClick={() => {
              if (post?.status !== 'published') {
                setIsEditImageModalOpen(true);
              }
            }}
            onClose={onClose}
            onFeedbackClick={() => setIsFeedbackModalOpen(true)}
          />
        )}
      </div>
    </div>
  );
};

export default PostModalContent;
